import { render, staticRenderFns } from "./Codelabs.vue?vue&type=template&id=5ebcfc78&"
import script from "./Codelabs.vue?vue&type=script&lang=js&"
export * from "./Codelabs.vue?vue&type=script&lang=js&"
import style0 from "./Codelabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports